import type { EvidencePointerschema } from '@reap/openapi-public-v1';

export interface ChatMessageAttachmentRecord {
  resourceType?: string;
  resourceId?: string;
  artifactId?: string;
  name?: string;
  mimeType?: string;
  sizeBytes?: number;
  evidence?: EvidencePointerschema[];
}

export interface ChatAttachmentArtifact {
  id: string;
  kind: string;
  summary?: string;
  size?: number;
  mimeType?: string;
  runId?: string;
  evidence?: EvidencePointerschema[];
  isFinalAttachment?: boolean;
}

interface ChatMessageWithAttachments {
  role?: string;
  runId?: string;
  attachments?: ChatMessageAttachmentRecord[];
}

export const isFileArtifactKind = (kind?: string | null): boolean => String(kind ?? '').trim().toLowerCase() === 'file';

export const formatArtifactSize = (bytes?: number): string | null => {
  if (typeof bytes !== 'number' || Number.isNaN(bytes)) {
    return null;
  }
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  const units = ['KB', 'MB', 'GB'];
  let size = bytes / 1024;
  let idx = 0;
  while (size >= 1024 && idx < units.length - 1) {
    size /= 1024;
    idx += 1;
  }
  return `${size.toFixed(1)} ${units[idx]}`;
};

export const mapAttachmentsToArtifacts = (message: ChatMessageWithAttachments): ChatAttachmentArtifact[] => {
  const runId = message.runId ?? undefined;
  const out: ChatAttachmentArtifact[] = [];
  (message.attachments ?? []).forEach((att) => {
    const resourceType = (att.resourceType ?? (att.artifactId ? 'artifact' : '')).trim().toLowerCase();
    const id = (att.resourceId ?? att.artifactId ?? '').trim();
    if (!id || !resourceType) {
      return;
    }
    out.push({
      id,
      kind: resourceType === 'file' ? 'file' : 'artifact',
      summary: att.name?.trim() || `${resourceType === 'file' ? 'File' : 'Artifact'} ${id.slice(0, 8)}…`,
      runId,
      mimeType: att.mimeType?.trim() || undefined,
      size: typeof att.sizeBytes === 'number' ? att.sizeBytes : undefined,
      evidence: att.evidence ?? undefined,
      isFinalAttachment: message.role === 'assistant'
    });
  });
  return out;
};
